import { App } from '../App';
import { UI } from '../UI';
import { User } from '../User';
import { bomColumns } from './columns';

import './scss/bomInfo.scss';

export const BOM = (function () {
  let info = (id, sku = null) => {
    if (!id) return;
    UI.blockPage();

    $.when(App.ajaxData(`SKUCatalog/bom-files-by-product/${id}`)).done((res) => {
      if (!res.isSuccess) {
        let error = res.errorInformation;
        if (error == null) {
          error = res.validationErrors[0].details[0].title;
        }
        return UI.errorMessage(error);
      }

      let bomData = res.data.length ? (sku ? res.data.filter((bom) => bom.sku === sku) : res.data) : [];

      let template = require('./tmpl/dialog.hbs');
      let productName = bomData[0]?.product?.name || '';

      bootbox
        .dialog({
          title: $lang.BOM.Billofmaterials,
          message: template({ $lang: $Lang, number: bomData.length, product: productName }),
          size: 'xl',
          className: 'modal-scrolled-content modal-bom-information'
        })
        .init(() => {
          init(bomData);
          UI.unblockPage();
        })
        .on('shown.bs.modal', () => {
          $(window).trigger('resize');
        });
    });
  };

  let init = (data) => {
    $('#bomInformationTbl').dataTable({
      columns: bomColumns,
      data: data,
      scrollX: true,
      cache: false,
      searching: false,
      ordering: false,
      dom: '<"row"<"col-sm-12"t>><"row mt-2"<"col-sm-12"p>>',
      drawCallback: () => {
        UI.unblock('#page');
        // Image popup
        $('.magnific-image').magnificPopup({ type: 'image' });
      },
      initComplete: () => {
        $('#bomInformationTbl_wrapper table thead').prepend(`
            <tr class="upper-header">
                <th colspan="3" class="upper-header">Identifiers</th>
                <th colspan="3" class="upper-header">Blank</th>
                <th colspan="1" class="upper-header">Panel</th>
                <th colspan="6" class="upper-header">Asset (Artwork / Printed trim)</th>
            </tr>
          `);
      }
    });
  };

  let submit = (idsCollection, type = 'bom', page = 'Prelisting', canContinue) => {
    let url = `prelistings/submit-${type}/${User.accountID()}`;

    UI.blockPage();
    $.when(App.ajaxData(url, { ids: idsCollection, canContinue }, 'POST')).done((res) => {
      unselectItems(page);

      UI.unblockPage();
      if (!res.isSuccess) {
        let additionalButtons = null;
        if (type === 'colorgate' && res?.errorInformation?.errorData?.every(err => err?.canContinue)) {
          additionalButtons = {
            Continue: {
              label: 'Continue',
              callback: function () {
                UI.btn.spinnerStopAll();
                UI.unblockPage();
                UI.unblock('*');

                submit(idsCollection, type, page, true);
              }
            }
          };
        }

        UI.errorMessage(res?.errorInformation?.errorReason || 'Unknown error', 'Error', false, additionalButtons);
        return;
      }
      if (res.artworks && res.description) {
        return missingFilesDialog(res.artworks, idsCollection, type, page);
      }

      submitSuccessHandler(idsCollection, type, page);
    });
  };

  let missingFilesDialog = (artworks, idsCollection, type, page) => {
    const bom = type === 'bom';

    const data = { $lang: $Lang, artworks: artworks, bom: bom };
    const template = require('./tmpl/missing-files.hbs');

    const buttons = bom
      ? {
          ok: { label: $lang.BOM.SubmitBOM, className: 'btn btn-brand', callback: () => submit(idsCollection, 'sap', page) },
          cancel: { label: $lang.btn.cancel, className: 'btn btn-link' }
        }
      : { ok: { label: $lang.btn.gotIt, className: 'btn btn-brand' } };

    bootbox.dialog({
      title: `<i class="fal fa-exclamation-triangle text-danger mr-2"></i> ${$lang.BOM.MissingRipfiles}`,
      message: template(data),
      size: 'large',
      className: 'modal-missing-ripfiles',
      buttons: buttons
    });
  };

  let unselectItems = (page) => {
    if (page == 'Prelisting') {
      App.pageData('selectAllPrelisting', false);
      App.pageData('selectPrelisting', []);
    }
    if (page == 'Listing') {
      App.pageData('selectAllListing', false);
      App.pageData('selectListing', []);
    }
  };

  let setStatusProgress = (idsCollection, type, page) => {
    if (page == 'dialog') {
      if (type !== 'colorgate') $(`.modal-body .bom-status`).removeClass().addClass('bom-status bom-inprocess');
      if (type !== 'sap') $(`.modal-body .rip-status`).removeClass().addClass('rip-status rip-inprocess');
      return;
    }
    Object.keys(idsCollection || {}).forEach((item) => {
      const rows =
        type === 'sap'
          ? $(`p[data-directory="BOM"][data-id="${item}"]`)
          : type === 'bom'
          ? $(`p[data-directory][data-id="${item}"]:not([data-action="logfolder"])`)
          : $(`p[data-directory][data-id="${item}"]:not([data-action="logfolder"]):not([data-directory="BOM"])`);

      $.each(rows, function () {
        const directory = $(this).data('directory');
        $(`p[data-directory="${directory}_log"][data-id="${item}"]`).remove();
        $(this).after(
          `<p data-directory="${directory}_log" data-id="${
            item
          }" class="align-items-center mb-3 mt-n2 text-muted"><i class="fal fa-spinner fa-pulse mr-2"></i>${directory}${
            directory !== 'BOM' ? ' rip files' : ''
          } submission in Process</p>`
        );

        $(`p[data-directory="${directory}"][data-id="${item}"] .status-label b`).removeClass().addClass('text-muted');
        $(`p[data-directory="${directory}"][data-id="${item}"] .status-label i`).removeClass().addClass('fal fa-folder-open fa-lg mr-1 text-muted');
      });
    });
  };

  let notifySuccess = (type) => {
    let mess;
    switch (type) {
      case 'sap':
        mess = $lang.alert.SuccessfullyStartedSubmitBOM;
        break;
      case 'colorgate':
        mess = $lang.alert.SuccessfullyStartedSubmitRIP;
        break;
      default:
        mess = $lang.alert.SuccessfullyStartedSubmitBOMRIP;
    }

    UI.notify({ text: mess, type: 'info', icon: 'fal fa-sync' });
  };

  let submitSuccessHandler = (idsCollection, type, page) => {
    setStatusProgress(idsCollection, type, page);
    notifySuccess(type);
  };

  return {
    info,
    submit
  };
})();
